import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5462741d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-img position-relative" }
const _hoisted_2 = {
  key: 0,
  class: "position-absolute shadow-md bg-white text-black rounded-pill p-2 mt-3 ms-4",
  style: {"z-index":"4"}
}
const _hoisted_3 = { class: "col-12 px-5 py-3" }
const _hoisted_4 = { class: "" }
const _hoisted_5 = { class: "mb-1 fw-normal" }
const _hoisted_6 = { class: "mb-4 fw-normal text-gray fs-sm" }
const _hoisted_7 = { class: "text-success fw-bold fs-6" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-md-3 p-0 position-relative" }
const _hoisted_10 = {
  key: 0,
  class: "position-absolute shadow-md bg-white text-black rounded-pill p-2 mt-3 ms-4",
  style: {"z-index":"4"}
}
const _hoisted_11 = { class: "col-md-5 px-5 py-7" }
const _hoisted_12 = { class: "mb-1 fw-bold fs-3" }
const _hoisted_13 = { class: "mb-1 text-gray" }
const _hoisted_14 = { class: "mb-2" }
const _hoisted_15 = { class: "text-success mb-0 fs-2 fw-bold" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-4 py-7 text-center" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "btn btn-primary" }, "Ver vehículo")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GalleryCard = _resolveComponent("GalleryCard")!
  const _component_router_link = _resolveComponent("router-link")!

  return (!!$props.vehicle)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        ($props.typeCard == 'cards')
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: { name: 'car-detail', params: { id: $props.vehicle.slug ? $props.vehicle.slug : 0  } },
              class: "card card-body rounded my-3 border-gray-600 p-0 col-12 position-relative"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  ($props.vehicle.status == 'Apartado')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString($props.vehicle.status), 1))
                    : _createCommentVNode("", true),
                  _createVNode(_component_GalleryCard, {
                    images: $props.vehicle.images
                  }, null, 8, ["images"])
                ]),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("p", _hoisted_5, _toDisplayString($props.vehicle.brand + " " + $props.vehicle.model + " " + $props.vehicle.version), 1),
                    _createElementVNode("p", _hoisted_6, _toDisplayString($props.vehicle.year) + " - " + _toDisplayString($setup.kmFormat($props.vehicle.Mileage) + " km") + " - " + _toDisplayString($props.vehicle.Estado), 1)
                  ]),
                  _createElementVNode("p", _hoisted_7, "$" + _toDisplayString($setup.formatPrice($props.vehicle.Price)), 1)
                ])
              ]),
              _: 1
            }, 8, ["to"]))
          : (_openBlock(), _createBlock(_component_router_link, {
              key: 1,
              class: "card card-body rounded my-3 border border-gray p-0 col-12 overflow-hidden",
              to: { name: 'car-detail', params: { id: $props.vehicle.slug } }
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    ($props.vehicle.status == 'Apartado')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString($props.vehicle.status), 1))
                      : _createCommentVNode("", true),
                    _createVNode(_component_GalleryCard, {
                      images: $props.vehicle.images
                    }, null, 8, ["images"])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("p", _hoisted_12, _toDisplayString($props.vehicle.brand + " " + $props.vehicle.model + " " + $props.vehicle.version), 1),
                    _createElementVNode("p", _hoisted_13, _toDisplayString($props.vehicle.year) + " - " + _toDisplayString($setup.kmFormat($props.vehicle.Mileage) + " km") + " - " + _toDisplayString($props.vehicle.Estado), 1),
                    _createElementVNode("p", _hoisted_14, _toDisplayString($props.vehicle.agency), 1),
                    _createElementVNode("p", _hoisted_15, "$" + _toDisplayString($setup.formatPrice($props.vehicle.Price)), 1)
                  ]),
                  _hoisted_16
                ])
              ]),
              _: 1
            }, 8, ["to"]))
      ], 64))
    : _createCommentVNode("", true)
}